<template>
<m-pageframe
    title="{organization_label}: Web Chat Analytics"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>
  <v-alert
      border="left"
      colored-border
      color="primary"
      elevation="2"
      type="info"
      dismissible
    >
      Order analytics are not real time &mdash; it typically takes a day (24 hours) for orders to count against a web chat request.
   </v-alert>

    <m-edit-time-period
        v-model="analytics_time_period"
        v-on:input="onChangeAnalyticsPeriod"
    />

    <v-row
        v-if="report != null"
    >
       <v-col>
            <div class="total-card">
                <p class="total-value">{{report.day_count}} Days</p>
                <p class="total-label">{{report.date_range}}</p>
            </div>
        </v-col>

        <v-col>
            <div class="total-card">
                <p class="total-value">{{parseInt(report.count_by_time.total).toLocaleString()}}</p>
                <p class="total-label">Web Chat Requests Received</p>
            </div>
        </v-col>

        <v-col
          v-if="report != null && report.order_attribution_supported"
        >
            <div class="total-card">
                <p class="total-value">{{'$'+parseInt(report.order_attribution_by_time.total).toLocaleString()}}</p>
                <p class="total-label">Order Value {{report.order_attribution_settings.attribution_proximity_days}} Days or Less After Web Chat Request</p>
            </div>
        </v-col>

        

    </v-row>



    <m-chart-histogram
      v-if="report != null"
      title="WebChat Requests"
      class="mt-6 mb-4"
      :labels="report.count_by_time.chart_js_labels"
      :data="report.count_by_time.chart_js_data"
    />

    <m-chart-donut
        v-if="report != null"
        title="WebChat Requests (by Inbox)"
        class="mt-6 mb-4"
        :labels="report.count_by_type.chart_js_labels"
        :data="report.count_by_type.chart_js_data"
        :table_headers="report.count_by_type.headers"
        :table_rows="report.count_by_type.rows"
      />

    <div
       v-if="report != null && report.order_attribution_supported"
    >
      <m-chart-histogram
        title="Order Attribution (Web Chat)"
        class="mt-6 mb-4"
        :labels="report.order_attribution_by_time.chart_js_labels"
        :data="report.order_attribution_by_time.chart_js_data"
        currency
      />

      <div
        style="margin-top: 30px; margin-bottom: 15px"
      >
        <b>Criteria for Order Attribution</b>
        <ul>
          <li>Customer created a web chat request within the {{report.order_attribution_settings.order_prox_days}} days before the order was placed</li>
          <li
            v-if="report.order_attribution_settings.exclude_order_types.length == 0"
          >
            The order may be of any type
          </li>
          <li
            v-if="report.order_attribution_settings.exclude_order_types.length != 0"
          >
            The order type <u>was not</u>
          </li>
          <ul
            v-if="report.order_attribution_settings.exclude_order_types.length != 0"
          >
            <li
              v-for="(item, key) in report.order_attribution_settings.exclude_order_types"
              :key="'ex_order_type_'+key"
            >
              {{item}}
            </li>
          </ul>
          <li>You can customze the order proximity and the types of orders used to caculate order attriubtion  <a style="text-decoration: underline;" v-on:click="onClickDefaultOrderTypes">by changing your organization's default order attribution settings</a>.</li>

           

        </ul>
      </div>

    </div>

    <m-chart-donut
      v-if="report != null && report.order_attribution_supported"
      title="Order Attribution (Web Chat)"
      class="mt-6 mb-4"
      :labels="report.order_attribution_by_order_type.chart_js_labels"
      :data="report.order_attribution_by_order_type.chart_js_data"
      :table_headers="report.order_attribution_by_order_type.headers"
      :table_rows="report.order_attribution_by_order_type.rows"
      currency
    />

    <m-chart-leaderboard
      v-if="report != null"
      title="Web Chat Response Leaderboard"
      :table_headers="report.by_responder.headers"
      :table_rows="report.by_responder.rows"
    />

    <div
        style="margin-bottom: 15px; margin-top: 15px;"
    >
        <b>Note:</b> There are a number of reasons that may cause the totals on the leaderboard may not match the totals by inbox.  Some possible reasons for a mismatch include: you might have received a web chat request that has not been responded to, or you may have closed a web chat without responding etc. 
    </div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

  data() {
    return {
      analytics_time_period: null,
      report: null,
    }
  },

  methods: {
    onChangeAnalyticsPeriod() {
      this.$rc.rest({
        'spinner': true,
        'endpoint': 'PUT: /api/v1/analytics/run-report/web-chat',
      
        'params' : {
            ...this.analytics_time_period
          },
      
        'on_success': (data) => {
            this.report = data;
          },
      
        'on_error': 'Unable to download web chat report',
      });
    },

    onClickDefaultOrderTypes()
    {
        this.$router.push({
            'name': 'settings-organization-order-attribution',
            'params' : {
                'organization_id': this.$rc.getOrganizationId()
            }
        });
    },
  },
  
}
</script>

<style lang="scss" scoped>
.total-card
{
    border: 1px solid rgba(0,0,0,0.15);
    
    padding-top: 30px;
    padding-bottom: 30px;

    padding-left: 15px;
    padding-right: 15px;
    text-align: center;

    margin-bottom: 15px;
}

.total-value
{
    font-weight: 700;
    font-size: 28px;
}

.total-label
{
    margin-bottom: -15px;
}
</style>